"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Order = exports.Field = exports.CategoryFieldField = exports.PostInteraction = exports.Type = exports.Interaction = exports.Access = exports.PostType = exports.HeaderType = void 0;
var HeaderType;
(function (HeaderType) {
    HeaderType["NONE"] = "NONE";
    HeaderType["COLOR"] = "COLOR";
    HeaderType["IMAGE"] = "IMAGE";
})(HeaderType = exports.HeaderType || (exports.HeaderType = {}));
var PostType;
(function (PostType) {
    PostType["DISCUSSION"] = "DISCUSSION";
    PostType["QUESTION"] = "QUESTION";
})(PostType = exports.PostType || (exports.PostType = {}));
var Access;
(function (Access) {
    Access["UNKNOWN"] = "UNKNOWN";
    Access["PUBLIC"] = "PUBLIC";
    Access["MEMBERS_ONLY"] = "MEMBERS_ONLY";
    Access["PRIVATE"] = "PRIVATE";
})(Access = exports.Access || (exports.Access = {}));
var Interaction;
(function (Interaction) {
    Interaction["UNKNOWN"] = "UNKNOWN";
    Interaction["REACTION"] = "REACTION";
    Interaction["VOTE"] = "VOTE";
    Interaction["NONE"] = "NONE";
})(Interaction = exports.Interaction || (exports.Interaction = {}));
var Type;
(function (Type) {
    Type["LIKE"] = "LIKE";
    Type["ANGRY"] = "ANGRY";
    Type["CLAP"] = "CLAP";
    Type["LOVE"] = "LOVE";
    Type["HAHA"] = "HAHA";
    Type["SAD"] = "SAD";
    Type["SMILE"] = "SMILE";
    Type["WOW"] = "WOW";
    Type["THINKING"] = "THINKING";
    Type["THUMBS_UP"] = "THUMBS_UP";
    Type["THUMBS_DOWN"] = "THUMBS_DOWN";
})(Type = exports.Type || (exports.Type = {}));
var PostInteraction;
(function (PostInteraction) {
    PostInteraction["UNKNOWN"] = "UNKNOWN";
    PostInteraction["REACTION"] = "REACTION";
    PostInteraction["NONE"] = "NONE";
})(PostInteraction = exports.PostInteraction || (exports.PostInteraction = {}));
var CategoryFieldField;
(function (CategoryFieldField) {
    CategoryFieldField["UNKNOWN"] = "UNKNOWN";
    /** Includes the category's URL. */
    CategoryFieldField["URL"] = "URL";
})(CategoryFieldField = exports.CategoryFieldField || (exports.CategoryFieldField = {}));
var Field;
(function (Field) {
    Field["UNKNOWN"] = "UNKNOWN";
    /** URL of the category. */
    Field["URL"] = "URL";
})(Field = exports.Field || (exports.Field = {}));
var Order;
(function (Order) {
    Order["ASC"] = "ASC";
    Order["DESC"] = "DESC";
})(Order = exports.Order || (exports.Order = {}));
//# sourceMappingURL=types.impl.js.map